export default {
  /* ================== mutations ============== */
  SET_COURSE_DETAIL: 'SET_COURSE_DETAIL',
  UPDATE_COURSE_DETAIL: 'UPDATE_COURSE_DETAIL',
  SET_RECOMMEND: 'SET_RECOMMEND',
  SET_COMMENT_LIST: 'SET_COMMENT_LIST',
  SET_COMMENT_TIPS: 'SET_COMMENT_TIPS',
  SET_GIFT_CARD: 'SET_GIFT_CARD',
  SET_LUBO_VIDEO: 'SET_LUBO_VIDEO',
  SET_IS_LOADED: 'SET_IS_LOADED',
  SET_PRESALE_STATUS: 'SET_PRESALE_STATUS',
  SET_INT_PURCHASE: 'SET_INT_PURCHASE',
  SET_CART_COUNT: 'SET_CART_COUNT',
  SET_DATA_LOADING: 'SET_DATA_LOADING',
  SET_ADD_CART: 'SET_ADD_CART',
  SET_COUPON_LIST: 'SET_COUPON_LIST',
  SET_COUPON_MESSSAGE: 'SET_COUPON_MESSSAGE',

  /* ================== actions ============== */
  GET_COURSE_DETAIL: 'GET_COURSE_DETAIL',
  GET_LOGIN_COURSE_DETAIL: 'GET_LOGIN_COURSE_DETAIL',
  GET_RECOMMEND: 'GET_RECOMMEND',
  GET_COMMENT_LIST: 'GET_COMMENT_LIST',
  SUBMIT_COMMENT: 'SUBMIT_COMMENT',
  GET_GIFT_CARD: 'GET_GIFT_CARD',
  GET_PRESALE_STATUS: 'GET_PRESALE_STATUS',
  GET_ADD_CART: 'GET_ADD_CART',
  GET_CART_COUNT: 'GET_CART_COUNT',
  GET_COUPON_LIST: 'GET_COUPON_LIST', // 优惠券列表
  GET_COUPON: 'GET_COUPON' // 优惠券
}



// WEBPACK FOOTER //
// ./src/views/CourseDetail/store/types.js